<template>
  <div class="modal fade" id="updateDisbursementDate">
    <div class="modal-dialog">
        <div class="modal-content">
        <div class="modal-header bg-aqua">
            <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            >
            <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">Update Disbursement Date</h4>
        </div>
        <form @submit.prevent="submitDisbursementdate()">
            <div class="modal-body">
            <!-- right column -->
                <div class="card card-warning">
                <!-- /.card-header -->
                <div class="card-body">
                    <singleloanmembershortdetail :singleLoanBranchDetail="singleLoanBranchDetail" :singleLoanMemberDetail="singleLoanMemberDetail"></singleloanmembershortdetail>
                    <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                        <label
                            >Disbursement Date <span class="red">*</span></label
                        >
                        <input
                            v-model="form.disbursementDate"
                            type="date"
                            name="disbursementDate"
                            class="form-control input-sm"
                            :class="{
                            'is-invalid': form.errors.has('disbursementDate'),
                            }"
                            required
                        />
                        <has-error
                            :form="form"
                            field="disbursementDate"
                        ></has-error>
                        </div>
                        
                    </div>
                    </div>
                </div>
                <!-- /.card-body -->
                </div>
                <!-- /.card -->
            </div>
            <div class="modal-footer text-center">
            <button
                type="submit"
                class="btn btn-success"
            >
                UPDATE
            </button>
            
            <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
            >
                CANCEL
            </button>
            </div>
        </form>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
</template>
<script>
import singleloanmembershortdetail from '../components/SingleLoanMemberShortDetails.vue'
export default {
  name: 'LoanDisbursementDateChange',
  data () {
    return {
      form: new Form({
        disbursementDate: ''
      })
    }
  },
  components: {
    singleloanmembershortdetail
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    submitDisbursementdate () {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Re-Settle it!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$axios
            .post(`updatedisbursementdate/${this.disbursementRecord.id}`, { 'disbursementDate': this.form.disbursementDate }, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
            .then((data) => {
              this.showloandisbursementdatechangemodal = 'no'
              $('#updateDisbursementDate').modal('hide')
              Toast.fire({
                icon: 'success',
                title: data.message
              })
              this.form.disbursementDate = ''
              Fire.$emit('AfterCreate')
            }).catch(function (error) { console.log(error) })
        }
      })
    }
  },
  props: {
    singleLoanBranchDetail: {},
    singleLoanMemberDetail: {},
    disbursementRecord: {}
  }
}
</script>



// WEBPACK FOOTER //
// LoanDisbursementDateChange.vue?5e9ad678